var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-row',{staticClass:"top-offset",attrs:{"no-gutters":""}},[_c('v-col',{attrs:{"cols":"12","lg":"12","md":"12"}},[_c('SearchDataTable')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }